<template>
  <div>
    <v-app-bar app class="print-ignore">
      <v-toolbar-title class="headline text-uppercase">
        <span>{{appTitle}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="printPage">
        <v-icon dark>print</v-icon>
        <span class="mr-2">印刷</span>
      </v-btn>
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <div class="contents">
          <div class="grid">
            <div class="grid-cell" :style="{textAlign: 'right'}">
              <span class="caption" :style="{color: 'gray'}">ver.{{version}}</span>
            </div>
          </div>
          <DecisionDisplay></DecisionDisplay>
        </div>
        <div class="contents">
          <div class="grid">
            <div class="grid-cell">
              <h1>基礎科目</h1>
            </div>
          </div>
          <div class="grid">
            <div class="grid-cell">
              <ResultCredit :title="'必修科目'" :item="kisoList.must" />
              <ResultCredit v-if="isApp2018" :title="'選択科目'" :item="kisoList.select" />
            </div>
            <div class="grid-cell">
              <ResultCredit v-if="isApp2018" :title="'自由科目'" :item="kisoList.free" />
              <ResultCredit v-if="isApp2019" :title="'選択科目'" :item="kisoList.select" />
            </div>
          </div>
        </div>

        <div class="print-break"></div>
        <v-divider class="print-ignore"></v-divider>
        <div class="contents">
          <div class="grid">
            <div class="grid-cell">
              <h1>専門基礎科目</h1>
            </div>
          </div>
          <div class="grid">
            <div class="grid-cell">
              <ResultCredit :title="'必修科目'" :item="senmonKisoList.must" />
              <ResultCredit v-if="isApp2018" :title="'選択科目'" :item="senmonKisoList.select" />
            </div>
            <div class="grid-cell">
              <ResultCredit v-if="isApp2018" :title="'自由科目'" :item="senmonKisoList.free" />
              <ResultCredit v-if="isApp2019" :title="'選択科目'" :item="senmonKisoList.select" />
            </div>
          </div>
        </div>

        <div class="print-break"></div>
        <v-divider class="print-ignore"></v-divider>
        <div class="contents">
          <div class="grid">
            <div class="grid-cell">
              <h1>専門科目({{senmon.label}})</h1>
            </div>
          </div>
          <div class="grid">
            <div class="grid-cell">
              <ResultCredit :title="'必修科目'" :item="senmonList.must" />
              <ResultCredit v-if="isApp2018" :title="'選択科目'" :item="senmonList.select" />
            </div>
            <div class="grid-cell">
              <ResultCredit v-if="isApp2018" :title="'自由科目'" :item="senmonList.free" />
              <ResultCredit v-if="isApp2019" :title="'選択科目'" :item="senmonList.select" />
            </div>
          </div>
        </div>
        <div class="print-break"></div>
        <v-divider class="print-ignore"></v-divider>
          <div class="contents">
            <div class="grid">
              <div class="grid-cell">
                <h1>卒業要件計算対象外</h1>
              </div>
            </div>
            <div class="grid">
              <div class="grid-cell">
                <ResultCreditOthers :list="remainList" />
              </div>
              <div class="grid-cell">
              </div>
            </div>
          </div>
          <div class="contents print-ignore">
            <div class="grid">
              <div class="grid-cell">
                <h1>総合評価D/F</h1>
              </div>
            </div>
            <div class="grid">
              <div class="grid-cell">
                <ResultCreditOthers :list="judgeDFList" />
              </div>
              <div class="grid-cell">
              </div>
            </div>
          </div>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import * as R from 'ramda'
import ResultCredit from '@/components/Result/ResultCredit.vue'
import ResultCreditOthers from '@/components/Result/ResultCreditOthers.vue'
const specJson = require('../../spec/spec' + process.env.VUE_APP_YEAR + '.json') // 順番はこれに従う
const requiredTypes = ['must', 'select', 'free']
import { mapState } from 'vuex'
import { VERSION, APP_TITLE } from '@/const'
import DecisionDisplay from '@/components/Result/DecisionDisplay.vue'
import {DecimalFilter} from '@/components/mixins/DecimalFilter'

export default {
  name: 'result-view',
  components: {
    ResultCredit,
    ResultCreditOthers,
    DecisionDisplay
  },
  mixins: [DecimalFilter],
  data () {
    return {
      kisoList: {
        must: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        },
        select: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        },
        free: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        }
      },
      senmonKisoList: {
        must: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        },
        select: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        },
        free: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        }
      },
      senmonList: {
        must: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        },
        select: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        },
        free: {
          list: [],
          limit: [],
          credit: 0,
          passed: false
        }
      },
      version: '',
      appTitle: APP_TITLE
    }
  },
  methods: {
    printPage () {
      window.print()
    },
  },
  computed: {
    ...mapState([
      'resultJson',
      'judgeDFList',
      'remainList',
      'senmon'
    ]),
    isApp2018 () { return process.env.VUE_APP_YEAR === '2018'},
    isApp2019 () { return process.env.VUE_APP_YEAR === '2019'}
  },
  created () {
    this.version = VERSION
    const loopList = R.keys(specJson.models)
    const getKamokuList = (top, requiredType) => {
      return R.pipe(
        R.view(R.lensPath([top, requiredType, 'conditions'])),
        R.pluck('label')
      )(specJson.models)
    }
    // この順番で出力できる
    for(let i = 0;i < loopList.length; i++ ){
      var top = loopList[i]
      for(let j = 0; j < requiredTypes.length; j ++) {
        var requiredType = requiredTypes[j]
        var list = getKamokuList(top, requiredType)
        // # 81 科目の合計
        const r = R.view(R.lensPath([top, requiredType, 'resultInfo']), this.resultJson.credits)
        if (r) {
          const { credit, limit, passed } = r
          switch (top) {
            case 'basic':
              this.kisoList[requiredType].credit = credit
              this.kisoList[requiredType].limit = limit
              this.kisoList[requiredType].passed = passed
              break;
            case 'special':
              this.senmonKisoList[requiredType].credit = credit
              this.senmonKisoList[requiredType].limit = limit
              this.senmonKisoList[requiredType].passed = passed
              break;
            default:
              this.senmonList[requiredType].credit = credit
              this.senmonList[requiredType].limit = limit
              this.senmonList[requiredType].passed = passed
              break;
          }
        }

        for (let k = 0; k < list.length; k++ ) {
          var label = list[k]
          const cource = R.view(R.lensPath([top, requiredType, 'cources' ,label]), this.resultJson.credits)
          if (cource) {
            let id = `${i}-${j}-${k}`
            let o = {id, cource, label}
            switch(top) {
              case 'basic':
                this.kisoList[requiredType].list.push(o)
              break;
              case 'special':
                this.senmonKisoList[requiredType].list.push(o)
              break;
              default:
                this.senmonList[requiredType].list.push(o)
              break;
            }
          }
        }
      }
    }
  },
  mounted () {
    document.title = this.resultJson.student.number
  }
}
</script>

<style>
.contents {
  /* max-width: 1200px; */
  /* min-width: 800px; */
  font-size: 13px;
  margin: auto;
  padding: 0;
}

.grid {
  margin: 0;
  padding: 0;
	display: -webkit-flex;
  display: flex;
  list-style: none;
}
.result-grid {
  /* justify-content: center */
}

.grid-cell {
  margin: 5px;
  padding: 0px;
  border-radius: 5px;
  line-height: 1;
  /* color: #fff; */
  /* background: #007bbb; */
  /* background: #eeeeee; */
  flex: 1;
}
.grid-cell-300 {
  padding-top: 20px;
  width: 400px;
  /* background-color: beige; */
  /* font-size: 23px; */
  font-size: 15px;
}
.grid-cell h3 {
  /* font-size: 50px; */
  padding-left: 10px
}

.twice {
  flex: 2;
}
.centering {
  text-align: center;
}
.textAlignLight {
  text-align: right;
}

/* .grid-cell p {
  display: block;
  margin: 0;
  padding: 20px;
  color: #fff;
  text-decoration: none;
} */

.grid-cell p {
  padding-left: 20px;
  line-height: 1
}
.grid-cell h1 {
  margin-top: 20px;
}
.result-cell {
  /* padding: 5px; */
  margin: 2px;
  /* font-size: 13px; */
  line-height: 1;
  /* text-align: right */
  /* background-color: darkgray; */
  /* text-align: right; */
}

@media print {
  /* .contents {
    width: 500;
  } */
  /* body {
    -webkit-print-color-adjust: exact;
  }

  .single-page {
    background-color: transparent !important;
  } */
  .v-content {
    /* padding: 0px 0px 0px; */
    padding: 0 !important;
  }

  .print-break {
    page-break-after: always;
  }
  .contents {
    font-size: 10px
  }
  .print-ignore {
    display: none
  }

  /* #close {
    display: none !important;
  } */
}
</style>
